
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OE_CheckinForm.html?raw';
import "../../moreCore/UI/SelectBox/SelectBox";
import GenericEntityView from '../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { OMclassnames, OMtypes } from "../_loadingHelpers/OM";
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import "../../moreCore/UI/RadioGroup/RadioGroup";
import PageStack from '../../moreCore/UI/Tabbing/PageStack';
import "../../moreCore/UI/Tabbing/PageStack";
import { HtmlHelpers, ToasterHelpers } from "../../more/Helpers";

interface FormData {
    employmentID: string,
    targetStatus: OMtypes.CheckinStatus;
}

class OE_CheckinForm extends compose(_uiFrameMixin) {
    templateString: any = template;

    
    private headingNode: HTMLElement;
    private sectionCheckin: HTMLElement;
    private btnCheckin: HTMLElement;

    private employmentID: string;
    private employmentData: OMtypes.orchestraEmploymentWithCheckin = null;

    private projectView: MdsLax<InstanceType<typeof GenericEntityView>>;
    private projectViewContainer: HTMLElement;
    private employmentView: MdsLax<InstanceType<typeof GenericEntityView>>;
    private employmentViewContainer: HTMLElement;

    private pageStack: MdsLax<InstanceType<typeof PageStack>>;

    private isReadOnly: boolean = true;

    private buttonClasses_CheckedIn = "primaryOutline mediumTransparentBG noInteraction";
    private buttonClasses_Available = "w3-green";
    private buttonClasses_Unavailable = "mediumTransparentBG w3-disabled";


    setup(employmentID: string) {

        this.UiModder.domConstruct.empty(this.employmentViewContainer);
        this.setReadonly();

        if (!employmentID) return;

        this._loadEmploymentData(employmentID);    
    }



    private _loadEmploymentData(employmentID?: string) {
        if (employmentID) this.employmentID = employmentID;
        employmentID = this.employmentID;

        this.hourGlassStart(this.domNode);

        if (!employmentID) return;

        let data = {
            employmentID: employmentID
        };

        this.RequestManager.callfunction("Webtool_API_OrchestraEmploymentCheckin__LoadEmploymentCheckin",
            data,
            lang.hitch(this, this._onLoadDataResponse),
            lang.hitch(this, this._onLoadDataError));

    }

    private _onLoadDataResponse(response: OMtypes.orchestraEmploymentWithCheckin) {
        this.hourGlassEnd(this.domNode);

        this.setData(response);
    }

    private _onLoadDataError(error: more.requestErrorMessage) {
        this.hourGlassEnd(this.domNode);
        ToasterHelpers.showToast({ title: "General__ProcessFailed", message: error.Message, iconClass: ToasterHelpers.ToasterIcons.error });

    }

    onShow() {
        if (!!this.currentDisplayMode) {
            this.hideNode(this.headingNode);
        }
    }

    setData(data: OMtypes.orchestraEmploymentWithCheckin) {
        this.employmentData = data;

        this.applyData();
    }

    private applyData() {
        this.UiModder.domConstruct.empty(this.employmentViewContainer);
        this.hideNode(this.employmentViewContainer);
        this.setReadonly();

        if (!this.employmentData) return;

        this.employmentID = this.employmentData.ID;

        this.setTitles(this.employmentData.gDisp_1);

        //this.headingNode.innerHTML = this.employmentData.gDisp_1;

        // entityview mit employment abrufen:
        //let container = this.UiModder.domConstruct.create("div");

        this.employmentView = new GenericEntityView();
        this.employmentView.setup(this.employmentID,
            OMclassnames.orchestra_employment,
            "EmploymentCheckin_MainTitle",
            null,
            this.employmentViewContainer, //container,
            null,
            "employment_checkin");


        //let exp = new ExpandableSection();
        //exp.placeAt(this.employmentViewContainer);
        //exp.setup(container, "General_Label_Details", "small");        

        this.hideNode(this.employmentViewContainer, false);

        this.getCurrentEmployeeId(lang.hitch(this, this._onGetCurrentEmployeeId), true);

        this._handleButtonStyle();

        switch (this.employmentData.tmp_presence_confirmation_availability) {
            case "unavailable":
            case "past_checked":
            case "past_unchecked":
            case "checked":
            default:
                this.disableNode(this.sectionCheckin);
                break;

            case "available":
                this.disableNode(this.sectionCheckin, false);
                break;
        }
    }   

    private _onGetCurrentEmployeeId(employeeId: string) {
        if (this.getCurrentEmployeeId(null, true) == this.employmentData?.ref_associate?.ID) {
            this.setReadonly(false);
        } 
    }


    private _handleButtonStyle() {
        //this.disableNode(this.btnCheckin, this.isReadOnly == true);

        this.UiModder.domConstruct.empty(this.btnCheckin);

        let currentStatusText: string = this.translate("EmploymentCheckin_BtnLabel__notCheckedIn");
        let statusIcon: string = "far fa-circle";
        let buttonClasses = this.buttonClasses_Unavailable;

        this.UiModder.domClass.remove(this.btnCheckin, this.buttonClasses_Available);
        this.UiModder.domClass.remove(this.btnCheckin, this.buttonClasses_CheckedIn);
        this.UiModder.domClass.remove(this.btnCheckin, this.buttonClasses_Unavailable);
        

        if (this.employmentData) {
            if (!this.isReadOnly) buttonClasses = this.buttonClasses_Available;

            switch (this.employmentData.presence_confirmation_status) {
                case "absent":
                    statusIcon = "fas fa-times-circle";
                    currentStatusText = this.translate("EmploymentCheckin_BtnLabel__absent");
                    buttonClasses = this.buttonClasses_CheckedIn;
                    break;

                case "present":
                    statusIcon = "fas fa-check-circle";
                    currentStatusText = this.translate("EmploymentCheckin_BtnLabel__present");
                    buttonClasses = this.buttonClasses_CheckedIn;
                    break;
            }
        }

        this.UiModder.domAttr.set(this.btnCheckin, "innerHTML", currentStatusText);
        this.UiModder.domClass.add(this.btnCheckin, buttonClasses);

        HtmlHelpers.createFontawesomeIcon(statusIcon, "right", this.btnCheckin);
    }

    private setReadonly(isReadonly?: boolean) {

        this.isReadOnly = isReadonly !== false;

        //this.disableNode(this.sectionCheckinButtons, this.isReadOnly == true);

        

        this._handleButtonStyle();
    }


    private _onClick_Checkin(evt: MouseEvent): void {

        
        if (!this.employmentData || this.isReadOnly) return;

        let targetStatus: OMtypes.CheckinStatus = "present";

        if (this.employmentData.presence_confirmation_status == targetStatus) return;

        this.hourGlassStart(this.sectionCheckin);

        let data: FormData = {
            employmentID: this.employmentID,
            targetStatus: targetStatus
        };

        this.RequestManager.callfunction("Webtool_API_OrchestraEmploymentCheckin__SaveCheckin",
            data,
            lang.hitch(this, this._onSaveResponse),
            lang.hitch(this, this._onSaveError),
            true
        );
    }

   

    private _onSaveResponse(response): void {
        this.hourGlassEnd(this.sectionCheckin);
        this._loadEmploymentData();

        ToasterHelpers.showToast("EmploymentCheckin_Message__CheckinSuccessful", ToasterHelpers.ToasterIcons.confirmCheck);

        this.emit("saved");
    }

    private _onSaveError(error: more.requestErrorMessage): void {
        this.hourGlassEnd(this.sectionCheckin);
        ToasterHelpers.showToast({ title: "General_SavingFailed", message: error.Message, iconClass: ToasterHelpers.ToasterIcons.error });
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setReadonly(true);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        //this.loadDutyTypes();
    }
}

export default mdsWidget(OE_CheckinForm);
